import React, { PropTypes } from 'react';
import Button from '../common/Button';
import { Modal } from 'react-overlays';
import TextInput from '../common/TextInput';
import SelectInput from '../common/SelectInput';
import { ITAAlert } from '../common/ITAAlert';
import '../../styles/modals/establishmentUserModal.css';

const backdropStyle = {
    position: 'fixed',
    top: 0, bottom: 0, left: 0, right: 0,
    zIndex: 'auto',
    backgroundColor: '#000',
    opacity: 0.5
};

const EstablishmentUserModal = ({
    establishmentUserEmailChange,
    establishmentUserRoleChange,
    showModal,
    closeModal,
    emailDefaultValue,
    roleDefaultOption,
    operationType,
    createEstablishmentUser,
    removeEstablishmentUsersList,
    displayAlert,
    updateEstablishmentUser,
    removeEstablishmentUser
}) => {
    const roles = ["ITA Establishment User", "ITA Establishment Admin"];
    let establishmentUserRoles = [];
    roles.map((role) => {
        let entry = {};
        entry.value = role;
        entry.key = role;
        establishmentUserRoles.push(entry);
    });
    const maxLengthForEstablishmentUserTextInputs = 100;
    let mode = removeEstablishmentUsersList.length > 0;
    const listEstablishmentsUsers = removeEstablishmentUsersList.map((esstablishmentUserName) =>
        <li>{esstablishmentUserName}</li>
    );
    let operation = operationType === 'C' ? 'Assign' : operationType === 'U' ? 'Edit' : 'Remove';
    return (
        <div >
            <Modal className="establishmentuser-modal" backdropStyle={backdropStyle} show={showModal}>
                <div className="establishmentuser-modal-dialog" id="establishmentuser-modal">
                    <div><h4 >{operation} Establishment User(s)</h4>
                    <div>Note: It may take 15 minutes for changes to reflect on the Establishment List and Establishment Details screens.</div></div>
                    {displayAlert && displayAlert != "" &&
                        <ITAAlert style="danger"
                            message={displayAlert} />
                    }
                    <div style={{marginTop: 10}}></div>
                    {operation == 'Remove' && <div >You have requested to remove the
                        following user from this establishment.
                    </div>}
                    {operation == 'Assign' && <div >You have requested to assign the
                        following user to this establishment.
                    </div>}
                    {operation == 'Edit' && <div >You have requested to Edit the
                        following user role for this establishment.
                    </div>}
                    {!mode && <form >
                        <div id="establishmentuser-info-container">
                            <TextInput type="text" label="Email" placeholder="Email" tooltip="Establishment User Email" required={true}
                                maxLength={maxLengthForEstablishmentUserTextInputs} onChange={establishmentUserEmailChange}
                                defaultValue={emailDefaultValue} disabled={operationType === 'U' ? true : false} />
                            <SelectInput name="Role" label="User Role" options={establishmentUserRoles} required={true}
                                onChange={establishmentUserRoleChange} defaultOption={roleDefaultOption} tooltip="Establishment User Role" />
                        </div>
                    </form>}
                    {mode && <ul>{listEstablishmentsUsers}</ul>}
                    <div className="establishmentuser-buttons-container pull-right">
                        <a disabled={false} onClick={closeModal}> Cancel </a>
                        {operationType == 'C' && <Button value="Save" className="save-establishmentuser-btn btn btn-primary"
                            disabled={false} onClick={createEstablishmentUser}
                        />}
                        {operationType == 'U' && <Button value="Save" className="save-establishmentuser-btn btn btn-primary"
                            disabled={false} onClick={updateEstablishmentUser}
                        />}
                        {operationType == 'D' && <Button value="Save" className="save-establishmentuser-btn btn btn-primary"
                            disabled={false} onClick={removeEstablishmentUser}
                        />}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

EstablishmentUserModal.propTypes = {
    establishmentUserEmailChange: PropTypes.func,
    establishmentUserRoleChange: PropTypes.func,
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.bool,
    emailDefaultValue: PropTypes.string,
    roleDefaultOption: PropTypes.string,
    operationType: PropTypes.string,
    createEstablishmentUser: PropTypes.func
};

export default EstablishmentUserModal;


/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentUsersModal.js
 **/